export const setFilledPercentage = (state, value) => {
  return {
    ...state,
    filledPercentage: value,
  };
}
